import { request } from '@/api/client';
import type {
  ConversationAnalyticsResponse,
  EchoAnalyticsSummaryResponse,
  ConsolidationStatusResponse,
  SuggestionClickParams,
} from '@/types/analytics';

/** Service for echo analytics, consolidation status, and suggestion CTR tracking. */
export const analyticsService = {
  /** Fetch conversation-level analytics for a given echo. */
  getConversationAnalytics: (echoId: string): Promise<ConversationAnalyticsResponse> =>
    request<ConversationAnalyticsResponse>(
      `/analytics/conversation/${encodeURIComponent(echoId)}`,
      { method: 'GET', auth: true }
    ),

  /** Fetch aggregated analytics summary for an echo. */
  getEchoSummary: (echoId: string): Promise<EchoAnalyticsSummaryResponse> =>
    request<EchoAnalyticsSummaryResponse>(`/analytics/echo/${encodeURIComponent(echoId)}/summary`, {
      method: 'GET',
      auth: true,
    }),

  /** Fetch memory consolidation status for a conversation. */
  getConsolidationStatus: (conversationId: string): Promise<ConsolidationStatusResponse> =>
    request<ConsolidationStatusResponse>(
      `/analytics/conversation/${encodeURIComponent(conversationId)}/consolidation-status`,
      { method: 'GET', auth: true }
    ),

  /** Record a suggested-question click for CTR tracking. */
  trackSuggestionClick: (params: SuggestionClickParams): Promise<{ status: string }> =>
    request<{ status: string }>('/analytics/events/suggestion-click', {
      method: 'POST',
      auth: true,
      body: JSON.stringify(params),
    }),
};
